import React, { memo } from "react";
import { Link, useCanShow, useCharity } from "@";
import { LazyLoadImage } from "react-lazy-load-image-component";

const Logo = ({ noStyle }) => {
  const { charityLogo, charityName, isLoading } = useCharity();

  return (
    <div className={noStyle ? "" : "relative mb-5 mt-3 px-4 lg:mt-6"}>
      <Link
        to={useCanShow("statistics") ? "/" : "#"}
        className="app-logo group relative flex items-center justify-center"
      >
        {/* Soft glow halo */}
        <span className="pointer-events-none absolute inset-0 -z-0 mx-auto h-20 w-20 rounded-full bg-gradient-to-br from-purple-200/60 via-purple-100/40 to-transparent blur-2xl transition-opacity duration-300 group-hover:opacity-90 dark:from-purple-700/30 dark:via-purple-900/30" />

        {isLoading ? (
          <span className="relative block h-16 w-16 animate-pulse rounded-2xl bg-gray-200 dark:bg-gray-700" />
        ) : (
          <span className="relative inline-flex max-h-[68px] w-[68px] items-center justify-center rounded-2xl bg-white p-1.5 shadow-sm ring-1 ring-gray-100 transition-all duration-300 group-hover:shadow-md group-hover:shadow-purple-900/10 group-hover:ring-purple-200 dark:bg-gray-800 dark:ring-gray-700 dark:group-hover:ring-purple-700">
            <LazyLoadImage
              width={58}
              height={60}
              alt={charityName}
              src={charityLogo}
              className="logo-png-sm h-full w-full rounded-2xl object-contain"
            />
          </span>
        )}
      </Link>
    </div>
  );
};

export default memo(Logo);
